import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { fetchProductCategories, fetchRawsList, importRaw } from '../../../../action/raw';
import { setUIvisible } from '../../../../action/UImobile';
import { setActiveModalAction } from '../../../../action';
import HeadMobileActionMenu from '../../../../components/utils/HeadMobileActionMenu';
import { CategoryListSemi } from '../../../../containers/semimanufactures/list/CategoryListSemi';
import { SemiList } from '../../../../containers';
import { fromStore } from '../../../../selectors';
import ErrorContainer from '../../../../components/utils/ErrorContainer';
import { utils, read, writeFileXLSX } from 'xlsx';
import swal from 'sweetalert';
import { groupBy, isEmpty } from 'lodash';
import { measuresVariable } from '../rawmaterials/RawMaterialsList';
import { importReceipes, receipesCount } from '../../../../action/recipes';
import { MEASURES_RAW } from '../../../../containers/rawmaterials/constansts';
import moment from 'moment';
import { parseNumToFixed } from '../../../../utils/common';

function SemimanufacturesList() {
    const dispatch = useDispatch();
    const activeCategory = useSelector(fromStore.activeCategoryRawSelector);
    const categories = useSelector(fromStore.categoriesRawByType('semi'));
    const raws = useSelector(fromStore.rawListSelector);
    const activeCategoryRaws = useSelector(fromStore.selectedCategoryRaws);
    const semis = useSelector(fromStore.selectedRawsByType('semi'))
    const refImport = useRef();
    const refImportReceipes = useRef();
    
    const actionsMobile = [
        { name: 'Добавить полуфабрикат', icon: 'flaticon2-plus', action: () => onOpenModalGood() },
        { name: 'Добавить категорию', icon: 'flaticon2-plus', action: () => onOpenModalCategory() },
        { name: 'Редактировать категорию', icon: 'la la-edit', action: () => onOpenModalCategory(activeCategory) },
    ];

    const onRefresh = () => {
        dispatch(fetchRawsList());
        dispatch(fetchProductCategories('semi'));
    };

    useEffect(() => {
        if (isEmpty(categories)) dispatch(fetchProductCategories('semi'));
        dispatch(setUIvisible(false, true));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch])

    const onOpenModalCategory = (id) => {
        const categoryId = id || 'new';
        dispatch(setActiveModalAction({ field: 'categoryRaw', value: {id: categoryId, type: 'semi' } }));
    };

    const onOpenModalGood = (id) =>  {
        const goodId = id || 'new';
        dispatch(setActiveModalAction({ field: 'modalRaw', value: { id: goodId, type: 'semi' } }));
    }

    const onImport = async (e) => {
        if (!e.target.files[0]) {
            refImport.current.value = "";
            return swal({
                title: "Ошибка импорта",
                text: 'Файл не загружен',
                icon: "error",
                dangerMode: true,
                button: "Ок",
            });
        }

        const file = e.target.files[0];

        if (!file.arrayBuffer) {
            refImport.current.value = "";
            return swal({
                title: "Ошибка импорта",
                text: 'Неверный формат данных',
                icon: "error",
                dangerMode: true,
                button: "Ок",
            });
        }

        const data = await file.arrayBuffer();

        if (!data) {
            refImport.current.value = "";
            return swal({
                title: "Ошибка импорта",
                text: 'Данные не найдены',
                icon: "error",
                dangerMode: true,
                button: "Ок",
            });
        }

        if(data) {
            const errors = [];

            const getMeasure = (text, name) => {
                if (!text) {
                    errors.push(`Не указана ед. измерения для полуфабриката ${name}`);
                    return null;
                }
                const result = measuresVariable.find((measure) => measure.variables.includes(text.toUpperCase()));
                if (result && result.value) return result.value;
                errors.push(`Ед. измерения ${text} не найдена`);
            }

            const getCategory = (text, name) => {
                if (!text) {
                    errors.push(`Не указана категория для полуфабриката ${name}. Полуфабрикат ${name} не был создано.`);
                    return null;
                }
                const result = categories.find((category) => String(category.title).toUpperCase() === String(text).toUpperCase());
                if (result && result.id) return result.id;
                errors.push(`Категория ${text} не найдена. Полуфабрикат ${name} не было создан.`);
            }

            const wb = read(data);
            const ws = wb.Sheets[wb.SheetNames[0]];
            const dataExcel = utils.sheet_to_json(ws);

            let rawmaterials = raws;
            if (isEmpty(rawmaterials)) rawmaterials = await dispatch(fetchRawsList(true, true));

            const importData = dataExcel.map((item) => {
                const name = item['Название'];
                const rawData = rawmaterials.find((raw) => raw.name.toUpperCase() === String(name).toUpperCase());
                const measure = getMeasure(item['Единица измерения'], name);
                const productscategory = getCategory(item['Категория'], name)
                if (!productscategory) return null;
                const weight = item['Вес'];
                const updated = (rawData && rawData.id) ? rawData.id : false;
                return { name, measure, productscategory, weight, updated};
            }).filter((item) => item);

            if (importData && importData.length > 0) {
                const result = await dispatch(importRaw(importData));
                if (result && errors.length === 0) {
                    refImport.current.value = "";
                    return swal({
                        title: "Импорт выполнен",
                        icon: "success",
                        button: "Ок",
                    });
                }

                if (!result || result.length === 0) {
                    refImport.current.value = "";
                    return swal({
                        title: "Неизвестная ошибка импорта",
                        icon: "warning",
                        dangerMode: true,
                        button: "Ок",
                    }).then(() => onRefresh());
                }

                if (result && result.length > 0 && errors.length > 0) {
                    const errorText = errors.join(' | ');
                    refImport.current.value = "";
                    return swal({
                        title: "Импорт выполнен с ошибками",
                        text: errorText,
                        icon: "warning",
                        dangerMode: true,
                        button: "Ок",
                    });
                }
            }
            const errorText = errors.join(' | ');
            return swal({
                title: "Импорт не выполнен",
                text: errorText,
                icon: "error",
                dangerMode: true,
                button: "Ок",
            });
        }
        refImport.current.value = "";
    }

    const onImportReceipes = async (e) => {
        if (!e.target.files[0]) {
            refImportReceipes.current.value = "";
            return swal({
                title: "Ошибка импорта",
                text: 'Файл не загружен',
                icon: "error",
                dangerMode: true,
                button: "Ок",
            });
        }

        const file = e.target.files[0];

        if (!file.arrayBuffer) {
            refImportReceipes.current.value = "";
            return swal({
                title: "Ошибка импорта",
                text: 'Неверный формат данных',
                icon: "error",
                dangerMode: true,
                button: "Ок",
            });
        }

        const data = await file.arrayBuffer();

        if (!data) {
            refImportReceipes.current.value = "";
            return swal({
                title: "Ошибка импорта",
                text: 'Данные не найдены',
                icon: "error",
                dangerMode: true,
                button: "Ок",
            });
        }

        if(data) {
            const errors = [];

            const getDate = (date) => {
                const parseDate = moment(date);
                const seconds = parseDate.seconds();
                if (seconds >= 30) return new Date(parseDate.add(1, 'minute').startOf('minute'));
                return new Date(parseDate.startOf('minute'));
            }

            let rawmaterials = raws;
            if (isEmpty(rawmaterials)) rawmaterials = await dispatch(fetchRawsList(true, true));

            const wb = read(data, { cellDates: true });
            const ws = wb.Sheets[wb.SheetNames[0]];
            const dataExcel = utils.sheet_to_json(ws);

            const groupedById = groupBy(dataExcel, (item) => item.id || "id полуфабриката не указан");
            const groupedData = Object.entries(groupedById).reduce((acc, [id, items]) => {
                const groupedByDate = groupBy(items, (item) => item['Дата'] || "Дата не указана");
                acc[id] = groupedByDate;
                return acc;
            }, {});

            const importData = (await Promise.all(Object.entries(groupedData).map(async ([id, groupedDate]) => {
                return await Promise.all((Object.entries(groupedDate).map(async ([date, items]) => {
                    const productId = parseInt(id);

                    if (!rawmaterials.find((raw) => raw.id === productId)) {
                        errors.push(`Полуфабрикат с id ${id} не найден. Рецепт не создан.`);
                        return null;
                    }
    
                    const count = await dispatch(receipesCount({productId: productId, type: 'semi'}));
                    if (count >= 3) {
                        errors.push(`Превышение ограничения кол-ва рецептов для полуфабриката с id ${id}. Чтобы создать новый рецепт - удалите старый. Рецепт не был создан.`);
                        return null;
                    }
                    const startDate = getDate(new Date(date));
                    const type = 'semi';

                    const ingredientsMap = new Map();

                    items.forEach((item) => {
                    const rawData = rawmaterials.find((raw) => raw.name.toUpperCase() === String(item['Название ингредиента']).toUpperCase());
                    if (!rawData) {
                        errors.push(`Ингредиент с названием ${item['Название ингредиента']} и типом ${item['Тип ингредиента']} не найден. Рецепт создан без него.`);
                        return null;
                    }
                    
                    const quantity = parseFloat(item['Кол-во ингредиента']) || 0;
                    const ingredientKey = `${rawData.id}_${rawData.productscategory.type}`;
                    
                    if (ingredientsMap.has(ingredientKey)) {
                        const entity = ingredientsMap.get(ingredientKey);
                        
                        Object.entries({ default: quantity }).forEach(([key, value]) => {
                            if (entity.quantity[key]) {
                                entity.quantity[key] += value;
                            } else {
                                entity.quantity[key] = value;
                            }
                        });
                    } else {
                        ingredientsMap.set(ingredientKey, {
                            id: rawData.id,
                            type: rawData.productscategory.type,
                            quantity: {
                                default: quantity
                            }
                        });
                    }
                });
                
                const ingredients = Array.from(ingredientsMap.values());
                    return {
                        startDate,
                        productId,
                        type,
                        ingredients
                    }
                })))
            }))).flat().filter((item) => item && item.ingredients && item.ingredients.length > 0);

            if (!importData || importData.length === 0) return swal({
                title: "Ошибка импорта. Не найдены ингредиенты.",
                icon: "warning",
                dangerMode: true,
                button: "Ок",
            }).then(() => onRefresh());

            if (importData && importData.length > 0) {
                const result = await dispatch(importReceipes(importData));
                if (result && errors.length === 0) {
                    refImportReceipes.current.value = "";
                    return swal({
                        title: "Импорт выполнен",
                        icon: "success",
                        button: "Ок",
                    });
                }

                if (!result || result.length === 0) {
                    refImportReceipes.current.value = "";
                    return swal({
                        title: "Неизвестная ошибка импорта",
                        icon: "warning",
                        dangerMode: true,
                        button: "Ок",
                    }).then(() => onRefresh());
                }

                if (result && result.length > 0 && errors.length > 0) {
                    const errorText = errors.join(' | ');
                    refImportReceipes.current.value = "";
                    return swal({
                        title: "Импорт выполнен с ошибками",
                        text: errorText,
                        icon: "warning",
                        dangerMode: true,
                        button: "Ок",
                    });
                }                
            }
            const errorText = errors.join(' | ');
            return swal({
                title: "Импорт не выполнен",
                text: errorText,
                icon: "error",
                dangerMode: true,
                button: "Ок",
            });
        }
        refImportReceipes.current.value = "";
    }

    const onExport = (getAll) => {
        const arr = getAll ? semis : activeCategoryRaws;
        const exportData = arr.map((raw) => ({
            'id': raw.id,
            'Название': raw.name,
            'Вес': parseNumToFixed(raw.weight, 3) || 0,
            'Единица измерения': MEASURES_RAW[raw.measure],
            'Категория': raw.productscategory.title,
        }));
        const ws = utils.json_to_sheet(exportData);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, "История закупок");
        
        const category = !getAll ? categories.find((cat) => cat.id === activeCategory) : null;
        const categoryTitle = category && category.title ? category.title : null;
        writeFileXLSX(wb, `Полуфабрикаты${(!getAll && categoryTitle) ? ` категория ${categoryTitle}` : ''}.xlsx`);
    }

    const renderSubHeader = () => {
        return (
            <div className="kt-subheader not-mt kt-grid__item">
                <div className="kt-container  kt-container--fluid">
                <div className="kt-subheader__main">
                    <h3 className="kt-subheader__title">Полуфабрикаты</h3>
                </div>
                <div className="kt-subheader__toolbar">
                    <button className="btn btn-dark btn-icon-sm" onClick={() => onExport(false)}>
                        Экспорт категории
                    </button>
                    <button className="btn btn-dark btn-icon-sm" onClick={() => onExport(true)}>
                        Экспорт все
                    </button>
                    <label className="btn btn-dark btn-icon-sm" style={{ cursor: 'pointer' }}>
                        <input type="file" onChange={onImport} ref={refImport} hidden/>
                        Импорт
                    </label>
                    <label className="btn btn-dark btn-icon-sm" style={{ cursor: 'pointer' }}>
                        <input type="file" onChange={onImportReceipes} ref={refImportReceipes} hidden/>
                        Импорт рецептов
                    </label>
                    {window.innerWidth > 1024 && <button 
                    onClick={((e) => {
                        e.stopPropagation();
                        onOpenModalGood();
                    })}
                    className="btn btn-success btn-icon-sm"
                    >
                        Добавить полуфабрикат
                    </button>}
                    <button onClick={onRefresh} className="btn btn-secondary btn-icon"><i className="la la-refresh"></i></button>
                </div>
            </div>
            </div>
        );
    };

    return (
        <div>
            <HeadMobileActionMenu actions={actionsMobile}/>
            { renderSubHeader() }
            <div className='kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid'>
                <ErrorContainer field="raws" hasCloseButton={true}/>
                <ErrorContainer field="categoryRaws" hasCloseButton={true}/>
                <div className="kt-grid kt-grid--desktop kt-grid--ver-desktop kt-todo goods">
                    <div className='kt-grid__item kt-portlet kt-todo__aside goods'>
                       <CategoryListSemi/>
                    </div>
                    <div className="kt-grid__item kt-grid__item--fluid kt-todo__content">
                        <SemiList/>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SemimanufacturesList;